// Shared loading / empty / error states. No blank screens.
import type { ReactNode } from "react";

export function EmptyState({
  title,
  message,
  icon = "○",
  action,
}: {
  title: string;
  message?: string;
  icon?: string;
  action?: ReactNode;
}) {
  return (
    <div className="card flex flex-col items-center justify-center gap-2 p-10 text-center">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-ink-100 text-ink-400">
        {icon}
      </div>
      <p className="text-sm font-medium text-ink-700">{title}</p>
      {message && <p className="max-w-md text-sm text-ink-500">{message}</p>}
      {action}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="card flex flex-col items-center justify-center gap-3 border-critical/20 bg-critical-50 p-10 text-center">
      <p className="text-sm font-medium text-critical-700">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn-ghost">
          Retry
        </button>
      )}
    </div>
  );
}

export function CardSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="card space-y-3 p-4">
      <div className="skeleton h-4 w-1/3" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton h-3 w-full" />
      ))}
    </div>
  );
}

export function KpiSkeletonRow({ count = 5 }: { count?: number }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card space-y-2 p-4">
          <div className="skeleton h-3 w-2/3" />
          <div className="skeleton h-7 w-1/2" />
        </div>
      ))}
    </div>
  );
}
